export default "__VITE_ASSET__CgvoxJ4Q__"